import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "previousButton", "nextButton", "counter"]
  static values = { index: Number }

  connect() {
    this.indexValue = this.normalizedIndex(this.hasIndexValue ? this.indexValue : 0)
    this.render()
  }

  previous(event) {
    event?.preventDefault()
    this.indexValue = this.normalizedIndex(this.indexValue - 1)
    this.render()
  }

  next(event) {
    event?.preventDefault()
    this.indexValue = this.normalizedIndex(this.indexValue + 1)
    this.render()
  }

  keydown(event) {
    if (event.key === "ArrowLeft") {
      this.previous(event)
    } else if (event.key === "ArrowRight") {
      this.next(event)
    }
  }

  refresh() {
    this.indexValue = this.normalizedIndex(this.indexValue)
    this.render()
  }

  render() {
    const count = this.slideTargets.length
    const activeIndex = this.normalizedIndex(this.indexValue)

    this.slideTargets.forEach((slide, index) => {
      const active = index === activeIndex
      slide.hidden = !active
      slide.classList.toggle("is-active", active)
    })

    if (this.hasPreviousButtonTarget) this.previousButtonTarget.disabled = count <= 1
    if (this.hasNextButtonTarget) this.nextButtonTarget.disabled = count <= 1
    if (this.hasCounterTarget) this.counterTarget.textContent = count > 0 ? `${activeIndex + 1} / ${count}` : "0 / 0"
  }

  normalizedIndex(index) {
    const count = this.slideTargets.length
    if (count === 0) return 0

    return ((Number(index) || 0) + count) % count
  }
}
